<template>
    <div class="summary-wrap ">
            <div class="title">款式信息</div>
            <img class="image" :src="category.main_image" />
            <p class="text-normal name">{{category.category_name_cn}}</p>
            <p class="text-333 price">￥{{category.price|price_format}}</p>
    </div>
</template>

<script>
    import C from '@/utils/constant'
    import {mapState} from 'vuex'
    export default {
        name: "Summary",
        data() {
            return {
            }
        },
        computed: {
            ...mapState({
                category: (state) => state.mtm.picked_category,
            }),
        },
        methods: {
        }
    }
</script>

<style scoped lang="scss">

    .summary-wrap {
        overflow-y: scroll;
        text-align: center;
        .title {
            height: 44px;
            line-height: 44px;
            font-size: 15px;
            font-weight: bold;
            color: #000000;
            text-align: center;
        }
        .name {
            margin: 20px 0;
            font-size: 16px;
            font-weight: bold;
        }

        .price {
            margin: 20px 0;
            font-size: 16px;
            font-weight: bold;
        }
        .image {
            width: 300px;
            height: 300px;
        }
    }
</style>
